export const WATCHLIST_ROW_COLORS = [
  { token: "blue", label: "蓝", background: "#1D314D", text: "#E7EEF9" },
  { token: "indigo", label: "靛", background: "#2A2F57", text: "#ECEBFA" },
  { token: "violet", label: "紫", background: "#3A2E59", text: "#F0EAFB" },
  { token: "teal", label: "青", background: "#1E4A4A", text: "#E5FAF9" },
  { token: "green", label: "绿", background: "#23483A", text: "#E7F8F0" },
  { token: "olive", label: "橄榄", background: "#3B4728", text: "#F2F8E5" },
  { token: "amber", label: "琥珀", background: "#4B3E24", text: "#FFF5E5" },
  { token: "orange", label: "橙", background: "#4C3326", text: "#FFEFE6" },
  { token: "rose", label: "玫瑰", background: "#4A2B36", text: "#FFEAF0" },
  { token: "slate", label: "石板", background: "#2E3542", text: "#EAF0F8" },
] as const;

export type WatchlistRowColorToken = (typeof WATCHLIST_ROW_COLORS)[number]["token"];

export function getWatchlistRowColor(token: string | null | undefined) {
  if (!token) {
    return null;
  }
  return WATCHLIST_ROW_COLORS.find((item) => item.token === token) || null;
}
